export const EventRegistrationPreviewDialog = 'EventRegistrationPreview';
